const c = (a, t = document) => t.querySelector(a), f = (a, t = document) => Array.from(t.querySelectorAll(a));
function w(a, t) {
  let e;
  return (...s) => {
    e && clearTimeout(e), e = setTimeout(() => a(...s), t);
  };
}
function b(a) {
  return new DOMParser().parseFromString(a, "text/html");
}
const _ = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
function T(a) {
  const t = () => f(_, a).filter((n) => n.offsetParent !== null), e = (n) => {
    if (n.key !== "Tab") return;
    const i = t();
    if (i.length === 0) return;
    const r = i[0], o = i[i.length - 1];
    n.shiftKey && document.activeElement === r ? (n.preventDefault(), o.focus()) : !n.shiftKey && document.activeElement === o && (n.preventDefault(), r.focus());
  };
  a.addEventListener("keydown", e);
  const s = t()[0];
  return s && s.focus({ preventScroll: !0 }), () => a.removeEventListener("keydown", e);
}
function y(a, t = 2600) {
  const e = c("#Toast");
  e && (e.textContent = a, e.classList.add("is-visible"), window.clearTimeout(Number(e.dataset.t)), e.dataset.t = String(window.setTimeout(() => e.classList.remove("is-visible"), t)));
}
function v(a, t, e = document) {
  e.dispatchEvent(new CustomEvent(a, { detail: t, bubbles: !0 }));
}
const O = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  debounce: w,
  emit: v,
  parseHTML: b,
  qs: c,
  qsa: f,
  toast: y,
  trapFocus: T
}, Symbol.toStringTag, { value: "Module" }));
class L extends HTMLElement {
  release = null;
  opener = null;
  connectedCallback() {
    this.addEventListener("click", (t) => {
      t.target.closest("[data-drawer-close]") && this.close();
    }), this.addEventListener("keydown", (t) => {
      t.key === "Escape" && this.close();
    });
  }
  open(t) {
    if (this.classList.contains("is-open")) return;
    this.opener = t ?? document.activeElement, this.classList.add("is-open"), this.setAttribute("open", ""), document.body.classList.add("drawer-open");
    const e = this.querySelector(".drawer__panel");
    e && (this.release = T(e)), this.opener?.setAttribute("aria-expanded", "true"), this.dispatchEvent(new CustomEvent("drawer:open"));
  }
  close() {
    this.classList.contains("is-open") && (this.classList.remove("is-open"), this.removeAttribute("open"), document.body.classList.remove("drawer-open"), this.release?.(), this.release = null, this.opener?.setAttribute("aria-expanded", "false"), this.opener?.focus({ preventScroll: !0 }), this.dispatchEvent(new CustomEvent("drawer:close")));
  }
  toggle(t) {
    this.classList.contains("is-open") ? this.close() : this.open(t);
  }
}
class $ extends L {
}
function N() {
  document.addEventListener("click", (a) => {
    const t = a.target.closest("[data-drawer-open]");
    if (!t) return;
    const e = t.dataset.drawerOpen;
    if (!e) return;
    const s = document.getElementById(e);
    s instanceof L && (a.preventDefault(), s.open(t));
  });
}
const S = { "Content-Type": "application/json", Accept: "application/json" };
function D() {
  const a = /* @__PURE__ */ new Set(), t = c("cart-drawer"), e = c("cart-page");
  if (t?.dataset.section && a.add(t.dataset.section), e) {
    const s = e.closest("[data-section]");
    s?.dataset.section && a.add(s.dataset.section);
  }
  return Array.from(a);
}
async function M(a, t) {
  const e = await fetch(a, { method: "POST", headers: S, body: JSON.stringify({ ...t, sections: D(), sections_url: window.location.pathname }) }), s = await e.json();
  if (!e.ok)
    throw new Error(s.description ?? s.message ?? window.theme.strings.cartError ?? "Cart error");
  return s;
}
async function P(a) {
  const t = a instanceof FormData ? Object.fromEntries(a.entries()) : a, e = await M(window.theme.routes.cartAdd + ".js", t), s = await R();
  return q(e.sections), I(s.item_count), v("theme:cart:add", { item: e, cart: s }), v("theme:cart:update", { cart: s }), s;
}
async function B(a, t) {
  const e = await M(window.theme.routes.cartChange + ".js", { line: a, quantity: t });
  return q(e.sections), I(e.item_count), v("theme:cart:update", { cart: e }), e;
}
async function F(a) {
  await fetch(window.theme.routes.cartUpdate + ".js", { method: "POST", headers: S, body: JSON.stringify({ note: a }) });
}
async function R() {
  return await (await fetch(window.theme.routes.cart + ".js", { headers: S })).json();
}
function I(a) {
  f("[data-cart-count]").forEach((t) => {
    t.textContent = String(a), t.toggleAttribute("hidden", a === 0);
  });
}
function q(a) {
  if (a)
    for (const [t, e] of Object.entries(a)) {
      const s = new DOMParser().parseFromString(e, "text/html"), n = c("cart-drawer");
      if (n && n.dataset.section === t) {
        const r = s.querySelector("cart-drawer");
        if (r) {
          const o = c("[data-cart-drawer-body]", n), d = r.querySelector("[data-cart-drawer-body]");
          o && d && (o.innerHTML = d.innerHTML);
          const l = c("[data-cart-drawer-footer]", n), u = r.querySelector("[data-cart-drawer-footer]");
          l && u ? l.innerHTML = u.innerHTML : l && !u ? l.remove() : !l && u && n.querySelector(".drawer__panel")?.appendChild(u);
          const p = c("[data-cart-count-label]", n), m = r.querySelector("[data-cart-count-label]");
          p && m && (p.textContent = m.textContent);
        }
      }
      const i = c("cart-page");
      if (i) {
        const r = i.closest("[data-section]");
        if (r?.dataset.section === t) {
          const o = s.querySelector("[data-section]");
          o && (r.innerHTML = o.innerHTML);
        }
      }
    }
}
function A(a) {
  a.addEventListener("click", async (t) => {
    const e = t.target.closest("[data-cart-remove]");
    e && (t.preventDefault(), await C(a, Number(e.dataset.line), 0));
  }), a.addEventListener("change", async (t) => {
    const e = t.target;
    e.matches("[data-quantity-input][data-index]") && await C(a, Number(e.dataset.index), Number(e.value));
  }), a.addEventListener(
    "input",
    w((t) => {
      const e = t.target;
      e.matches("[data-cart-note]") && F(e.value);
    }, 400)
  );
}
async function C(a, t, e) {
  const s = c("[data-cart-items]", a);
  s?.classList.add("is-loading");
  try {
    await B(t, e);
  } catch (n) {
    const i = c(`.cart-item[data-line="${t}"] [data-line-error]`, a), r = n instanceof Error ? n.message : window.theme.strings.cartError ?? "Error";
    i ? (i.textContent = r, i.hidden = !1) : y(r);
  } finally {
    s?.classList.remove("is-loading");
  }
}
class V extends L {
  connectedCallback() {
    super.connectedCallback(), A(this), document.addEventListener("theme:cart:add", () => {
      window.theme.cartType === "drawer" && this.open(document.getElementById("CartIcon"));
    });
  }
}
class j extends HTMLElement {
  connectedCallback() {
    A(this);
  }
}
class U extends HTMLElement {
  connectedCallback() {
    const t = this.querySelector("input");
    t && this.querySelectorAll("button").forEach((e) => {
      e.addEventListener("click", (s) => {
        s.preventDefault();
        const n = Number(t.step) || 1, i = Number(t.min) || 0, r = t.max ? Number(t.max) : 1 / 0;
        let o = Number(t.value) || 0;
        o = e.name === "plus" ? o + n : o - n, o = Math.min(r, Math.max(i, o)), t.value = String(o), t.dispatchEvent(new Event("change", { bubbles: !0 }));
      });
    });
  }
}
class z extends HTMLElement {
  connectedCallback() {
    const t = this.querySelector("form");
    t && t.addEventListener("submit", async (e) => {
      e.preventDefault();
      const s = t.querySelector('[type="submit"]'), n = c("[data-error]", t);
      if (s?.disabled) return;
      s?.classList.add("btn--loading"), s?.setAttribute("aria-busy", "true"), n && (n.hidden = !0);
      const i = new FormData(t);
      try {
        if (await P(i), (window.theme.cartType !== "drawer" || !document.querySelector("cart-drawer")) && y(window.theme.strings.added ?? "Added to cart"), t.matches(".quick-add-form")) {
          const r = s?.querySelector("span");
          if (r) {
            const o = r.textContent;
            r.textContent = window.theme.strings.added ?? "Added", setTimeout(() => r.textContent = o, 1800);
          }
        }
      } catch (r) {
        const o = r instanceof Error ? r.message : window.theme.strings.cartError ?? "Error";
        n ? (n.textContent = o, n.hidden = !1) : y(o);
      } finally {
        s?.classList.remove("btn--loading"), s?.removeAttribute("aria-busy");
      }
    });
  }
}
class K extends HTMLElement {
  variants = [];
  abort = null;
  connectedCallback() {
    const t = this.querySelector("[data-variants]")?.textContent;
    if (t)
      try {
        this.variants = JSON.parse(t);
      } catch {
        this.variants = [];
      }
    this.addEventListener("change", () => this.onChange()), this.markUnavailable();
  }
  /** The enclosing section element (not this element, which carries its own data-section). */
  get section() {
    return (this.parentElement ?? this).closest("section[data-section], .shopify-section");
  }
  selectedOptions() {
    return f("fieldset", this).map((t) => {
      const e = t.querySelector('input[type="radio"]:checked');
      return e ? e.value : t.querySelector("select")?.value ?? "";
    });
  }
  currentVariant() {
    const t = this.selectedOptions();
    return this.variants.find((e) => e.options.every((s, n) => s === t[n]));
  }
  markUnavailable() {
    const t = this.selectedOptions();
    f("fieldset", this).forEach((e, s) => {
      f('input[type="radio"]', e).forEach((n) => {
        const i = [...t];
        i[s] = n.value;
        const r = this.variants.find((d) => d.options.every((l, u) => l === i[u]));
        e.querySelector(`label[for="${n.id}"]`)?.classList.toggle("is-unavailable", !r || !r.available);
      });
    });
  }
  onChange() {
    f("fieldset", this).forEach((r) => {
      const o = r.querySelector("[data-selected-value]"), d = r.querySelector('input[type="radio"]:checked'), l = r.querySelector("select");
      o && (o.textContent = d?.value ?? l?.value ?? "");
    }), this.markUnavailable();
    const t = this.currentVariant(), e = this.section, s = e?.querySelector("[data-variant-id]"), n = e?.querySelector("[data-add-to-cart]"), i = n?.querySelector("[data-add-to-cart-text]");
    if (!t) {
      s && (s.disabled = !0), n && (n.disabled = !0), i && (i.textContent = window.theme.strings.unavailable ?? "Unavailable");
      return;
    }
    if (s && (s.value = String(t.id), s.disabled = !t.available), n && (n.disabled = !t.available), i && (i.textContent = t.available ? window.theme.strings.addToCart ?? "Add to cart" : window.theme.strings.soldOut ?? "Sold out"), this.dataset.updateUrl === "true") {
      const r = new URL(window.location.href);
      r.searchParams.set("variant", String(t.id)), window.history.replaceState({}, "", r);
    }
    t.featured_media?.id && e?.querySelector("product-gallery")?.setActive(t.featured_media.id), this.renderSection(t.id);
  }
  async renderSection(t) {
    const e = this.dataset.section, s = this.dataset.url;
    if (!(!e || !s)) {
      this.abort?.abort(), this.abort = new AbortController();
      try {
        const n = await fetch(`${s}?variant=${t}&section_id=${e}`, { signal: this.abort.signal }), i = b(await n.text()), r = this.section;
        if (!r) return;
        ["[data-price-wrapper]", "[data-inventory]", "[data-pickup-wrapper]", "[data-sku]", "[data-sale-badge]"].forEach((l) => {
          const u = i.querySelector(l), p = c(l, r);
          u && p && (p.innerHTML = u.innerHTML, p.toggleAttribute("hidden", u.hasAttribute("hidden")));
        });
        const o = c("[data-sticky-price]", r), d = i.querySelector("[data-price-current]");
        o && d && (o.textContent = d.textContent);
      } catch {
      }
    }
  }
}
class J extends HTMLElement {
  slides = [];
  thumbs = [];
  connectedCallback() {
    this.slides = f("[data-media-id]", c("[data-gallery-main]", this) ?? this), this.thumbs = f("[data-gallery-thumbs] [data-media-id]", this), this.thumbs.forEach((n) => n.addEventListener("click", () => this.setActive(Number(n.dataset.mediaId)))), c("[data-gallery-prev]", this)?.addEventListener("click", () => this.step(-1)), c("[data-gallery-next]", this)?.addEventListener("click", () => this.step(1));
    const t = c("[data-gallery-main]", this);
    let e = 0;
    t?.addEventListener("touchstart", (n) => e = n.touches[0]?.clientX ?? 0, { passive: !0 }), t?.addEventListener(
      "touchend",
      (n) => {
        const i = (n.changedTouches[0]?.clientX ?? 0) - e;
        Math.abs(i) > 40 && this.step(i < 0 ? 1 : -1);
      },
      { passive: !0 }
    ), this.addEventListener("keydown", (n) => {
      n.key === "ArrowLeft" && this.step(-1), n.key === "ArrowRight" && this.step(1);
    });
    const s = c("[data-lightbox]", this);
    s && (this.addEventListener("click", (n) => {
      const i = n.target.closest("[data-zoom-src]");
      if (!i) return;
      const r = c("[data-lightbox-img]", s);
      r && (r.src = i.dataset.zoomSrc ?? ""), s.showModal();
    }), c("[data-lightbox-close]", s)?.addEventListener("click", () => s.close()), s.addEventListener("click", (n) => {
      n.target === s && s.close();
    }));
  }
  activeIndex() {
    return Math.max(0, this.slides.findIndex((t) => t.classList.contains("is-active")));
  }
  step(t) {
    if (this.slides.length < 2) return;
    const e = (this.activeIndex() + t + this.slides.length) % this.slides.length, s = this.slides[e]?.dataset.mediaId;
    s && this.setActive(Number(s));
  }
  setActive(t) {
    this.slides.forEach((e) => {
      const s = Number(e.dataset.mediaId) === t;
      e.classList.toggle("is-active", s), e.hidden = !s, s || e.querySelectorAll("video").forEach((n) => n.pause());
    }), this.thumbs.forEach((e) => {
      const s = Number(e.dataset.mediaId) === t;
      e.classList.toggle("is-active", s), s ? (e.setAttribute("aria-current", "true"), e.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" })) : e.removeAttribute("aria-current");
    });
  }
}
class W extends HTMLElement {
  connectedCallback() {
    const t = this.dataset.target, e = t ? document.getElementById(t) : null, s = e?.querySelector('form[data-type="add-to-cart-form"]');
    if (!e || !s) return;
    this.hidden = !1, new IntersectionObserver(
      ([i]) => {
        if (!i) return;
        const r = i.boundingClientRect.bottom < 0;
        this.classList.toggle("is-visible", r && !i.isIntersecting);
      },
      { threshold: 0 }
    ).observe(s), this.querySelector("[data-sticky-atc-btn]")?.addEventListener("click", () => {
      if (s.querySelector("[data-add-to-cart]")?.disabled) {
        s.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      s.requestSubmit();
    });
  }
}
class G extends HTMLElement {
  connectedCallback() {
    let t = -1;
    const e = () => {
      const i = Math.round(this.getBoundingClientRect().height);
      i === t || i <= 0 || i > 400 || (t = i, document.documentElement.style.setProperty("--header-offset", `${i}px`));
    };
    if (e(), new ResizeObserver(e).observe(this), this.dataset.sticky === "true") {
      const i = () => this.classList.toggle("is-stuck", window.scrollY > 8);
      i(), window.addEventListener("scroll", i, { passive: !0 });
    }
    const s = f("[data-nav-details]", this), n = window.matchMedia("(hover: hover) and (min-width: 1024px)");
    s.forEach((i) => {
      if (i.addEventListener("toggle", () => {
        i.open && s.forEach((r) => r !== i && (r.open = !1));
      }), n.matches) {
        let r;
        i.addEventListener("mouseenter", () => {
          clearTimeout(r), i.open = !0;
        }), i.addEventListener("mouseleave", () => {
          r = setTimeout(() => i.open = !1, 120);
        });
      }
    }), document.addEventListener("click", (i) => {
      this.contains(i.target) || s.forEach((r) => r.open = !1);
    }), document.addEventListener("keydown", (i) => {
      i.key === "Escape" && s.forEach((r) => r.open = !1);
    });
  }
}
class Y extends HTMLElement {
  input;
  results;
  abort = null;
  cache = /* @__PURE__ */ new Map();
  connectedCallback() {
    const t = c("[data-search-input]", this), e = c("[data-predictive-results]", this);
    !t || !e || this.dataset.enabled !== "true" || (this.input = t, this.results = e, t.addEventListener("input", w(() => {
      this.search();
    }, 220)), t.addEventListener("focus", () => {
      t.value.trim().length > 1 && this.results.innerHTML && this.show(), this.toggleClear();
    }), t.addEventListener("keydown", (s) => this.onKey(s)), c("[data-search-clear]", this)?.addEventListener("click", () => {
      t.value = "", t.focus(), this.hide(), this.toggleClear();
    }), document.addEventListener("click", (s) => {
      this.contains(s.target) || this.hide();
    }));
  }
  toggleClear() {
    const t = c("[data-search-clear]", this);
    t && (t.hidden = this.input.value.length === 0);
  }
  async search() {
    this.toggleClear();
    const t = this.input.value.trim();
    if (t.length < 2) {
      this.hide();
      return;
    }
    const e = this.cache.get(t);
    if (e) {
      this.render(e);
      return;
    }
    this.abort?.abort(), this.abort = new AbortController(), this.results.innerHTML || (this.results.innerHTML = '<div class="predictive__loading">…</div>'), this.show();
    const s = `${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(t)}&resources[type]=product,collection,page,article,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag&section_id=predictive-search`;
    try {
      const n = await fetch(s, { signal: this.abort.signal }), r = b(await n.text()).querySelector("[data-predictive-inner]")?.outerHTML ?? "";
      this.cache.set(t, r), this.render(r);
    } catch {
    }
  }
  render(t) {
    this.results.innerHTML = t, this.show();
  }
  show() {
    this.results.hidden = !1, this.input.setAttribute("aria-expanded", "true");
  }
  hide() {
    this.results.hidden = !0, this.input.setAttribute("aria-expanded", "false");
  }
  onKey(t) {
    const e = f("[data-predictive-option]", this.results);
    if (this.results.hidden || e.length === 0) return;
    const s = e.findIndex((n) => n.getAttribute("aria-selected") === "true");
    if (t.key === "ArrowDown" || t.key === "ArrowUp") {
      t.preventDefault();
      const n = t.key === "ArrowDown" ? Math.min(s + 1, e.length - 1) : Math.max(s - 1, 0);
      e.forEach((i, r) => i.setAttribute("aria-selected", String(r === n))), e[n]?.scrollIntoView({ block: "nearest" });
    } else t.key === "Enter" && s >= 0 ? (t.preventDefault(), e[s]?.click()) : t.key === "Escape" && this.hide();
  }
}
class X extends HTMLElement {
  form;
  abort = null;
  connectedCallback() {
    const t = c("[data-facets-form]", this);
    t && (this.form = t, this.addEventListener("submit", (e) => e.preventDefault()), this.addEventListener("change", (e) => {
      const s = e.target;
      s.closest("[data-facets-form]") && (s.matches('input[type="number"]') || this.apply());
    }), this.addEventListener(
      "input",
      w((e) => {
        e.target.matches('[data-facets-form] input[type="number"]') && this.apply();
      }, 500)
    ), this.addEventListener("click", (e) => {
      const s = e.target, n = s.closest("[data-facet-remove]");
      if (n) {
        e.preventDefault(), this.load(n.href);
        return;
      }
      s.closest("[data-facets-open]") ? this.openPanel() : s.closest("[data-facets-close]") && this.closePanel();
    }), document.addEventListener("keydown", (e) => e.key === "Escape" && this.closePanel()), window.addEventListener("popstate", () => {
      this.load(window.location.href, !1);
    }));
  }
  openPanel() {
    this.classList.add("is-open");
    const t = c("[data-facets-overlay], .facets__overlay", this);
    t && (t.hidden = !1), c("[data-facets-open]", this)?.setAttribute("aria-expanded", "true"), document.body.classList.add("drawer-open");
  }
  closePanel() {
    this.classList.remove("is-open");
    const t = c(".facets__overlay", this);
    t && (t.hidden = !0), c("[data-facets-open]", this)?.setAttribute("aria-expanded", "false"), document.body.classList.remove("drawer-open");
  }
  apply() {
    const t = c("[data-facets-form]", this);
    if (!t) return;
    this.form = t;
    const e = new URLSearchParams();
    new FormData(this.form).forEach((n, i) => {
      String(n).trim() !== "" && e.append(i, String(n));
    });
    const s = `${window.location.pathname}?${e.toString()}`;
    this.load(s);
  }
  async load(t, e = !0) {
    const s = this.dataset.section;
    if (!s) {
      window.location.href = t;
      return;
    }
    this.abort?.abort(), this.abort = new AbortController();
    const n = c("[data-product-grid]");
    n?.classList.add("is-loading");
    const i = t.includes("?") ? "&" : "?";
    try {
      const r = await fetch(`${t}${i}section_id=${s}`, { signal: this.abort.signal }), o = b(await r.text()), d = o.querySelector("[data-product-grid]");
      n && d && (n.innerHTML = d.innerHTML);
      const l = new Set(f("[data-facet-group]", this).filter((m) => m.open).map((m) => m.dataset.facetGroup)), u = this.classList.contains("is-open"), p = o.querySelector("facet-filters");
      p && (this.innerHTML = p.innerHTML, this.form = c("[data-facets-form]", this), f("[data-facet-group]", this).forEach((m) => {
        l.size && (m.open = l.has(m.dataset.facetGroup));
      }), u && this.openPanel()), e && window.history.pushState({}, "", t), n?.scrollIntoView({ block: "start", behavior: "smooth" });
    } catch {
    } finally {
      n?.classList.remove("is-loading");
    }
  }
}
class Z extends HTMLElement {
  timer;
  connectedCallback() {
    this.render(), this.timer = setInterval(() => this.render(), 3e4);
  }
  disconnectedCallback() {
    this.timer && clearInterval(this.timer);
  }
  nowInZone() {
    const t = this.dataset.tz ?? "Australia/Brisbane", e = new Intl.DateTimeFormat("en-AU", { timeZone: t, hour12: !1, weekday: "short", hour: "2-digit", minute: "2-digit" }).formatToParts(/* @__PURE__ */ new Date()), s = (d) => e.find((l) => l.type === d)?.value ?? "", i = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(s("weekday")), o = Number(s("hour")) % 24 * 60 + Number(s("minute"));
    return { day: i === 0 ? 7 : i, minutes: o, weekday: i };
  }
  render() {
    const t = (Number(this.dataset.cutoff) || 12) * 60, e = (this.dataset.days ?? "1,2,3,4,5").split(",").map(Number), { day: s, minutes: n } = this.nowInZone(), i = this.querySelector("[data-dispatch-text]");
    if (!i) return;
    const r = ["", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    if (e.includes(s) && n < t) {
      const o = t - n, d = Math.floor(o / 60), l = o % 60, u = d > 0 ? `${d}h ${l}m` : `${l} min`;
      i.textContent = (window.theme.strings.dispatchMessage ?? "Order within [time] for same-day dispatch").replace("[time]", u);
    } else {
      let o = s;
      for (let l = 1; l <= 7; l += 1) {
        const u = (s - 1 + l) % 7 + 1;
        if (e.includes(u)) {
          o = u;
          break;
        }
      }
      const d = o === s % 7 + 1 ? "tomorrow" : r[o] ?? "";
      i.textContent = (window.theme.strings.dispatchNext ?? "Order now for dispatch [day]").replace("[day]", d);
    }
    this.hidden = !1;
  }
}
const Q = "https://a.klaviyo.com/client/subscriptions/", tt = "2024-10-15";
class et extends HTMLElement {
  form = null;
  submitting = !1;
  connectedCallback() {
    this.form = this.querySelector("form"), this.form && this.form.addEventListener("submit", this.onSubmit);
  }
  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }
  get companyId() {
    return this.dataset.company ?? "";
  }
  get listId() {
    return this.dataset.list ?? "";
  }
  onSubmit = (t) => {
    !this.companyId || !this.listId || this.submitting || (t.preventDefault(), this.subscribe());
  };
  field(t) {
    return this.querySelector(`[name="${t}"]`);
  }
  setStatus(t, e) {
    const s = this.querySelector("[data-klaviyo-status]");
    s && (s.textContent = t, s.className = e === "success" ? "form-success text-sm" : "form-errors text-sm", s.hidden = !1);
  }
  /**
   * Also creates the Shopify customer the native form would have created, so the
   * customer list keeps collecting newsletter signups. Failures are ignored: Klaviyo
   * has already accepted the subscription and Shopify rejects duplicates by design.
   */
  mirrorToShopify() {
    const t = this.form;
    t && fetch(t.action, {
      method: "POST",
      body: new FormData(t),
      headers: { Accept: "text/html" },
      keepalive: !0
    }).catch(() => {
    });
  }
  async subscribe() {
    const t = this.field("contact[email]")?.value.trim() ?? "";
    if (!t) return;
    const e = this.querySelector("button[type=submit]"), s = this.dataset.busyText ?? "Subscribing…", n = e?.textContent ?? "";
    this.submitting = !0, e && (e.disabled = !0, e.textContent = s);
    const i = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: this.dataset.source ?? "Website newsletter",
          profile: {
            data: {
              type: "profile",
              attributes: { email: t, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } }
            }
          }
        },
        relationships: { list: { data: { type: "list", id: this.listId } } }
      }
    };
    try {
      const r = await fetch(`${Q}?company_id=${encodeURIComponent(this.companyId)}`, {
        method: "POST",
        headers: { "content-type": "application/json", revision: tt },
        body: JSON.stringify(i)
      });
      if (!r.ok) throw new Error(`Klaviyo responded ${r.status}`);
      this.mirrorToShopify(), this.setStatus(this.dataset.successText ?? "Thanks for subscribing.", "success");
      const o = this.querySelector(".newsletter-form__row");
      o && (o.hidden = !0), window.klaviyo?.push(["identify", { $email: t }]), document.dispatchEvent(new CustomEvent("theme:newsletter:subscribe", { detail: { email: t, listId: this.listId } }));
    } catch {
      e && (e.disabled = !1, e.textContent = n), this.submitting = !1, this.form?.submit();
      return;
    }
    e && (e.disabled = !1, e.textContent = n), this.submitting = !1;
  }
}
const st = "https://a.klaviyo.com/client", nt = "2024-10-15", it = (a) => {
  const t = a.replace(/[\s()-]/g, "");
  return /^\+[1-9]\d{7,14}$/.test(t) ? t : /^0[45]\d{8}$/.test(t) ? `+61${t.slice(1)}` : /^0[2378]\d{8}$/.test(t) ? `+61${t.slice(1)}` : null;
};
class at extends HTMLElement {
  form = null;
  connectedCallback() {
    this.form = this.querySelector("form"), this.form && this.form.addEventListener("submit", this.onSubmit);
  }
  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }
  post(t, e) {
    const s = this.dataset.company ?? "";
    s && fetch(`${st}/${t}/?company_id=${encodeURIComponent(s)}`, {
      method: "POST",
      headers: { "content-type": "application/json", revision: nt },
      body: JSON.stringify(e),
      keepalive: !0
    }).catch(() => {
    });
  }
  /** Fires alongside the native submit; never blocks or cancels it. */
  onSubmit = () => {
    const t = this.form;
    if (!t) return;
    const e = new FormData(t), s = {};
    for (const [m, g] of e.entries()) {
      if (typeof g != "string") continue;
      const k = /^contact\[(.+)\]$/.exec(m);
      if (!k?.[1]) continue;
      const x = k[1];
      x === "g-recaptcha-response" || g.trim() === "" || (s[x] = g.trim());
    }
    const n = s.email;
    if (!n) return;
    const i = s.name ?? "", r = i.indexOf(" "), o = s.phone ? it(s.phone) : null, d = { email: n };
    i && (d.first_name = r > 0 ? i.slice(0, r) : i, r > 0 && (d.last_name = i.slice(r + 1))), s.company && (d.organization = s.company), o && (d.phone_number = o), d.properties = { ...s, source_form: this.dataset.source ?? "Contact form" };
    const l = this.dataset.event;
    l && this.post("events", {
      data: {
        type: "event",
        attributes: {
          properties: { ...s, page: window.location.pathname },
          metric: { data: { type: "metric", attributes: { name: l } } },
          profile: { data: { type: "profile", attributes: d } }
        }
      }
    });
    const u = this.dataset.list, p = this.querySelector("[data-klaviyo-optin]");
    if (u && p?.checked) {
      const m = { email: { marketing: { consent: "SUBSCRIBED" } } };
      this.post("subscriptions", {
        data: {
          type: "subscription",
          attributes: {
            custom_source: this.dataset.source ?? "Contact form",
            profile: { data: { type: "profile", attributes: { ...d, subscriptions: m } } }
          },
          relationships: { list: { data: { type: "list", id: u } } }
        }
      });
    }
  };
}
class rt extends HTMLElement {
  connectedCallback() {
    const t = f(".announcement__message", this);
    if (t.length < 2) return;
    let e = 0;
    const s = (Number(this.dataset.interval) || 5) * 1e3;
    setInterval(() => {
      t[e].hidden = !0, t[e].classList.remove("is-active"), e = (e + 1) % t.length, t[e].hidden = !1, t[e].classList.add("is-active");
    }, s);
  }
}
class ot extends HTMLElement {
  connectedCallback() {
    const t = this.dataset.url;
    if (!t) return;
    const e = new IntersectionObserver(
      (s) => {
        s.some((n) => n.isIntersecting) && (e.disconnect(), fetch(t).then((n) => n.text()).then((n) => {
          const i = b(n).querySelector("product-recommendations");
          i?.innerHTML.trim() ? this.innerHTML = i.innerHTML : this.remove();
        }).catch(() => this.remove()));
      },
      { rootMargin: "400px 0px" }
    );
    e.observe(this);
  }
}
const E = "spherify-hsg:recently-viewed";
function ct() {
  const t = c("recently-viewed[data-current]")?.dataset.current ?? document.querySelector("[data-product-handle]")?.dataset.productHandle;
  if (t)
    try {
      const e = JSON.parse(localStorage.getItem(E) ?? "[]").filter((s) => s !== t);
      e.unshift(t), localStorage.setItem(E, JSON.stringify(e.slice(0, 12)));
    } catch {
    }
}
class dt extends HTMLElement {
  connectedCallback() {
    let t = [];
    try {
      t = JSON.parse(localStorage.getItem(E) ?? "[]");
    } catch {
      return;
    }
    const e = this.dataset.current;
    if (t = t.filter((n) => n !== e).slice(0, Number(this.dataset.limit) || 5), t.length === 0) return;
    const s = c("[data-recently-viewed-grid]", this);
    s && Promise.all(
      t.map(
        (n) => fetch(`${window.theme.routes.root}products/${n}?section_id=product-card-fragment`.replace("//", "/")).then((i) => i.ok ? i.text() : "").catch(() => "")
      )
    ).then((n) => {
      const i = n.map((r) => b(r).querySelector(".product-card")?.outerHTML ?? "").filter(Boolean).join("");
      i && (s.innerHTML = i, this.hidden = !1);
    });
  }
}
class lt extends HTMLElement {
  connectedCallback() {
    const t = c("[data-carousel-track]", this), e = c("[data-carousel-prev]", this), s = c("[data-carousel-next]", this);
    if (!t) return;
    const n = () => {
      e && (e.disabled = t.scrollLeft <= 4), s && (s.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4);
    }, i = () => t.clientWidth * 0.9;
    e?.addEventListener("click", () => t.scrollBy({ left: -i(), behavior: "smooth" })), s?.addEventListener("click", () => t.scrollBy({ left: i(), behavior: "smooth" })), t.addEventListener("scroll", n, { passive: !0 }), window.addEventListener("resize", n), n();
  }
}
class ut extends HTMLElement {
  connectedCallback() {
    const t = () => this.hidden = window.scrollY < 600;
    t(), window.addEventListener("scroll", t, { passive: !0 }), this.querySelector("button")?.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
  }
}
class ht extends HTMLElement {
  connectedCallback() {
    this.querySelector("button")?.addEventListener("click", async () => {
      const t = this.dataset.url ?? window.location.href, e = this.dataset.title ?? document.title;
      if (navigator.share)
        try {
          await navigator.share({ url: t, title: e });
        } catch {
        }
      else {
        await navigator.clipboard.writeText(t);
        const { toast: s } = await Promise.resolve().then(() => O);
        s("Link copied");
      }
    });
  }
}
class ft extends HTMLElement {
  connectedCallback() {
    const t = c("[data-video-play]", this), e = this.dataset.src;
    !t || !e || t.addEventListener("click", () => {
      const s = mt(e);
      s && (this.innerHTML = `<iframe src="${s}" title="Video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>`);
    });
  }
}
function mt(a) {
  const t = a.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
  if (t) return `https://www.youtube-nocookie.com/embed/${t[1]}?autoplay=1&rel=0`;
  const e = a.match(/vimeo\.com\/(\d+)/);
  return e ? `https://player.vimeo.com/video/${e[1]}?autoplay=1` : null;
}
function H() {
  const a = f("[data-animate]");
  if (a.length === 0 || !("IntersectionObserver" in window)) return;
  const t = new IntersectionObserver(
    (e) => e.forEach((s) => s.isIntersecting && (s.target.classList.add("is-visible"), t.unobserve(s.target))),
    { rootMargin: "0px 0px -10% 0px" }
  );
  a.forEach((e) => t.observe(e));
}
function pt() {
  document.addEventListener("click", (t) => {
    const e = t.target.closest("[data-address-toggle]");
    if (!e) return;
    const s = document.getElementById(e.dataset.addressToggle ?? "");
    s && (s.hidden = !s.hidden, e.setAttribute("aria-expanded", String(!s.hidden)));
  });
  const a = () => {
    const t = window.Shopify?.CountryProvinceSelector;
    return t ? (f("[data-address-country]").forEach((e) => {
      const s = e.closest("form")?.querySelector("[data-address-province]");
      if (!s) return;
      const n = s.closest(".field");
      n && !n.id && (n.id = `${s.id}_container`), new t(e.id, s.id, { hideElement: n?.id ?? s.id });
    }), !0) : !1;
  };
  c("[data-address-country]") && !a() && window.addEventListener("load", a);
}
const h = (a, t) => {
  customElements.get(a) || customElements.define(a, t);
};
h("menu-drawer", $);
h("cart-drawer", V);
h("cart-page", j);
h("quantity-input", U);
h("product-form", z);
h("variant-selector", K);
h("product-gallery", J);
h("sticky-atc", W);
h("sticky-header", G);
h("predictive-search", Y);
h("facet-filters", X);
h("dispatch-countdown", Z);
h("klaviyo-subscribe", et);
h("klaviyo-form", at);
h("announcement-bar", rt);
h("product-recommendations", ot);
h("recently-viewed", dt);
h("product-carousel", lt);
h("back-to-top", ut);
h("share-button", ht);
h("deferred-video", ft);
N();
H();
pt();
ct();
document.addEventListener("shopify:section:load", () => H());
document.addEventListener("shopify:section:unload", () => document.querySelectorAll("menu-drawer, cart-drawer").forEach((a) => a.close()));
